'use strict';

// Provider logo assets, hosted on the EatLove static CDN.
const PROVIDER_LOGO_IMAGES = {
    fitbit: 'https://static.chewba.info/images/fitbit-app-icon.svg',
    google_health: 'https://static.chewba.info/images/e0685137-e5b7-4f55-ac17-e303bdd9596f.png',
};

export const getProviderLogo = (provider) => PROVIDER_LOGO_IMAGES[provider] || null;
